module.exports = __webpack_public_path__ + "static/media/applause.d5efd592.mp3";